import React, { useState, useEffect, useMemo } from "react";
import DataTable from "react-data-table-component";
import { TextField } from "@mui/material";
import { dataTableCustomStyles } from "../../ListPage";

const WordpressSuites = (props) => {
  const [tableData, setTableData] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    if (props.data) {
      setTableData(props.data);
    }
  }, [props.data]);

  let columns = props.showSuiteId
    ? [
        {
          name: "Suite ID(s)",
          selector: (row) => {
            const ids = row.suiteIds?.ids;
            if (ids && Array.isArray(ids)) {
              return ids.join(", ");
            }
            return "—";
          },
          sortable: false,
        },
        {
          name: "Name",
          selector: "name",
          sortable: true,
        },
      ]
    : [
        {
          name: "ID",
          selector: "id",
          sortable: true,
        },
        {
          name: "Name",
          selector: "name",
          sortable: true,
        },
      ];

  const handleFilterText = (event) => {
    setFilterText(event.target.value);
  };

  const filteredItems = tableData.filter(
    (item) =>
      item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="subHeader">
        <div className="subHeaderText">
          {props.selectedRows && props.selectedRows.length > 0 && (
            <h5 className="subHeaderTextContent">
              {props.selectedRows.length} Selected
            </h5>
          )}
        </div>
        <TextField
          id="filter-text"
          onChange={handleFilterText}
          label="Search"
          variant="outlined"
          size="small"
        />
      </div>
    );
  }, [filterText, props.selectedRows]);

  return (
    <div>
      <DataTable
        selectableRows
        onSelectedRowsChange={props.onSelectedRowsChange}
        selectableRowDisabled={(row) => {
          return props.disabled;
        }}
        selectableRowSelected={(row) => {
          if (props.selectedRows) {
            for (var i = 0; i < props.selectedRows.length; i++) {
              if (props.selectedRows[i].id == row.id) {
                return true;
              }
            }
            return false;
          } else {
            return false;
          }
        }}
        columns={columns}
        data={filteredItems}
        pagination
        paginationPerPage={5}
        paginationRowsPerPageOptions={[5]}
        noHeader={true}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        customStyles={dataTableCustomStyles}
      />
    </div>
  );
};

export default WordpressSuites;
